var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8BitCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8 8",
    style: {
      enableBackground: "new 0 0 8 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 1.6,
    width: 1.6,
    height: 1.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 3.2,
    width: 1.6,
    height: 1.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 1.6,
    width: 1.6,
    height: 1.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4.8,
    y: 4.8,
    width: 1.6,
    height: 1.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 4.8,
    width: 1.6,
    height: 1.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    y: 6.4,
    width: 1.6,
    height: 1.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.4,
    width: 1.6,
    height: 1.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1.6,
    height: 1.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 6.4,
    width: 1.6,
    height: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8BitCross);
export default __webpack_public_path__ + "static/media/8-bit_cross.3ebdbf93c3f33929bc4555c63a8c89c8.svg";
export { ForwardRef as ReactComponent };